/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SensorReadingDTO } from './sensorReadingDTO';


export interface MonitoringMachineResponseDTO { 
    sensors?: Array<SensorReadingDTO>;
    healthPercentage?: number;
    machineType?: MonitoringMachineResponseDTO.MachineTypeEnum;
    monitoringSupportStatus?: MonitoringMachineResponseDTO.MonitoringSupportStatusEnum;
}
export namespace MonitoringMachineResponseDTO {
    export const MachineTypeEnum = {
        IntegratedDirectDriveSeparator: 'INTEGRATED_DIRECT_DRIVE_SEPARATOR',
        Decanter: 'DECANTER',
        DirectDriveSeparator: 'DIRECT_DRIVE_SEPARATOR',
        FlatBeltSeparator: 'FLAT_BELT_SEPARATOR',
        GearboxSeparator: 'GEARBOX_SEPARATOR',
        CodestrykeSystems: 'CODESTRYKE_SYSTEMS'
    } as const;
    export type MachineTypeEnum = typeof MachineTypeEnum[keyof typeof MachineTypeEnum];
    export const MonitoringSupportStatusEnum = {
        HealthMonitorAvailable: 'HEALTH_MONITOR_AVAILABLE',
        CodestrykeAvailable: 'CODESTRYKE_AVAILABLE',
        NoCmAvailable: 'NO_CM_AVAILABLE'
    } as const;
    export type MonitoringSupportStatusEnum = typeof MonitoringSupportStatusEnum[keyof typeof MonitoringSupportStatusEnum];
}


